import {Box, WithStyles, withStyles} from '@material-ui/core';
import {userLevelStatus} from 'common/strings';
import LevelStatus from 'components/LevelStatus';
import React from 'react';
import {CurrentUser} from 'screens/common/CurrentUser';
import UserAvatar from 'screens/common/UserAvatar';
import {rieltor} from 'styles/theme';
import ProLabel from '../../components/ProLabel';
import {useIsMobile} from '../RegistrationInfoScreen/hooks';
import {useIsRieltorApp} from '../../hooks/useIsRieltorApp';

export const styles = {
  avatarContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    columnGap: '16px',
    alignItems: 'center',
  },
  avatarUserInfo: {
    display: 'flex',
    flexFlow: 'column nowrap',
    fontFamily: rieltor.fontFamily,
    fontStyle: 'normal',
    color: '#fff',
    flexGrow: 1,
  },
  avatarUserInfoName: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  avatarUserInfoJob: {
    fontSize: '12px',
    display: 'flex',
    flexFlow: 'row nowrap',
    columnGap: '8px',
    alignItems: 'center',
  },
  avatarImg: {
    width: 40,
    height: 40,
  }
};

export interface HeaderAvatarProps extends WithStyles<typeof styles> {
  avatarSize?: number;
}

const HeaderAvatar = (
  {
    avatarSize = 60,
    classes
  }: HeaderAvatarProps
) => {
  const isMobile = useIsMobile();
  const isRieltorApp = useIsRieltorApp();

  return (
    <div className={classes.avatarContainer}>
      <CurrentUser>
        {({user}) => {
          if (user === null) {
            return null;
          }

          return (
            <>
              <UserAvatar
                imageKey={user.avatar}
                width={avatarSize}
                height={avatarSize}
                placement={isMobile ? 60 : 48}
              />

              <Box className={classes.avatarUserInfo} display={'flex'}>
                <Box className={classes.avatarUserInfoName}>{user.username}</Box>
                <Box className={classes.avatarUserInfoJob}>
                  {userLevelStatus(user)}

                  {<ProLabel variant={isMobile ? 'big' : 'small'}/>}
                </Box>
              </Box>

              <div style={{width: 46}}>
                <LevelStatus status={user.levelStatus}/>
              </div>
            </>
          );
        }}
      </CurrentUser>
    </div>
  );
};

const StyledHeaderAvatar = withStyles(styles)(HeaderAvatar);

export default StyledHeaderAvatar;

export const MobileHeaderAvatar = withStyles({
  avatarContainer: {
    alignItems: 'flex-start',
  },
  avatarUserInfo: {
    rowGap: '10px',
  },
  avatarUserInfoName: {
    fontSize: '20px',
    fontWeight: 700,
  },
  avatarUserInfoJob: {
    fontSize: '14px',
  }
})(StyledHeaderAvatar);
